import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../general/Header';
import SubHeader from '../general/SubHeader';
import '../css/components/ProductDetails.css';
import ResponseMsg from '../general/ResponseMsg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Loading from '../general/Loading';


const ProductDetails = ({ isUser, userData }) => {
      const [response, setResponse] = useState(null);
      const [cart, setCart] = useState([]);
    const location = useLocation();
    const product = location.state?.product;
        const [selectedImage, setSelectedImage] = useState('');
    const [isInCart, setIsInCart] = useState(false);
    const [showUploadBtn, setShowUploadBtn] = useState(false);
  const [prescriptionFile, setPrescriptionFile] = useState(null);
  const [prescription, setPrescription] = useState([]);
  const [loading, setLoading] = useState(false);
const [cartQty, setCartQty] = useState(1);
const [cartId, setCartId] = useState(1);


    useEffect(() => {
        if(userData != null){
fetchPrescription();
    updateCartFromStorage();
            }

  // const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
  // // const found = existingCart.some(item => item.medicine_id === product.medicine_id);
  // const foundItem = existingCart.find(
  //   item => item.medicine_id === product.medicine_id
  // );

}, [userData?.id]);


useEffect(() => {
  const existingCart = cart || [];

  const foundItem = existingCart.find(
    item =>
      item.prod_name?.trim().toLowerCase() ===
      product.name?.trim().toLowerCase()
  );

  console.log(foundItem);

  if (foundItem) {
    setIsInCart(true);
    setCartQty(foundItem.quantity);
    setCartId(foundItem.id);
  } else {
    setIsInCart(false);
    setCartQty(1);
  }
}, [cart, product.name]);

    if (!product) {
        return <div>No product details available</div>;
    }

    
                            const updateCartFromStorage = async () => {
        const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
        setCart(sortedProducts || []);
        } else {
            setCart([]);
        }

    };

            const fetchPrescription = async () => {
          setLoading(true);
          try {
            const response = await fetch(`https://api.kcmstore.in/store/get-prescription/${userData.id}?prod_name=${product.name}`);
            setLoading(false);
            if (response.ok) {
              const data = await response.json();
              console.log(data);
                            const sortedProducts = data.sort((a, b) => b.id - a.id);
              setPrescription(sortedProducts);
            } else {
              console.error('Failed to fetch prescription');
            }
          } catch (error) {
            setLoading(false);
            console.error('Error fetching prescription:', error);
          }
        };
        

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'});
      };
    

      const handleAddCart = async (product) => {
        // console.log(product);
        if(!isUser){
          setResponse('Login to your account first.');
          setTimeout(() => {
            setResponse('');
          }, 2000)
          return;
        }  

//         if(product.subadmin_state  != userData.state){
//   setResponse('Delivery not available in your Area.');
//   setTimeout(() => {
//     setResponse('');
//   }, 2000)
//   return;
// }

          // if (!product || !product.medicine_id) {
          //   console.error('Invalid product data');
          //   setTimeout(() => {
          //     setResponse('');
          //   }, 2000)
          //   return;
          // }
        
          if (product.stock == '0') {
            setResponse('This product is currently out of stock.');
            setTimeout(() => {
              setResponse('');
            }, 2000)
            return;
          }

const presForProductAll = prescription.filter(
  (pres) =>
    pres.prod_name?.toLowerCase() == product.name?.toLowerCase()
);

  const presForProduct = presForProductAll.reduce((latest, pres) => {
    if (!latest) return pres;
    return new Date(pres.req_on) > new Date(latest.req_on) ? pres : latest;
  }, null);

  if (product.added_pres === 'yes') {
    if (!presForProduct) {
      setResponse('Upload Medical Prescription to Order this Medicine.');
      setShowUploadBtn(true);
      setTimeout(() => setResponse(''), 3000);
      return;
    }

    if (presForProduct.status === 'Approved') {
      setResponse('Prescription approved. You can order now.');
    } else if (presForProduct.status === 'Pending') {
      setResponse('Prescription not Approved yet. Wait for Approval.');
      setTimeout(() => setResponse(''), 3000);
      return;
    } else {
      setResponse('Prescription not Approved. Please upload again.');
      setShowUploadBtn(true);
      setTimeout(() => setResponse(''), 3000);
      return;
    }
  }
          // if(product.added_pres == 'yes'){
          //   setResponse('Upload Medical Prescription to Order this Medicine.');
          //   setShowUploadBtn(true);
          //   setTimeout(() => {
          //     setResponse('');
          //   }, 2000)
          //   return;
          // }
        
          // const existingCart = JSON.parse(localStorage.getItem('cart')) || []; 
          
          // if (!Array.isArray(existingCart)) {
          //   console.error('Error: existingCart is not an array');
          //   return;
          // }


          // const productIndex = existingCart.findIndex(item => item.medicine_id === product.medicine_id);
       

          // if (productIndex === -1) {
          //   existingCart.push({ ...product, quantity: 1 });
          // } else {
          //   existingCart[productIndex].quantity += 1;
          // }
        
          // localStorage.setItem('cart', JSON.stringify(existingCart));
          // setCart(existingCart);
          setIsInCart(true);
               try {
    const response = await fetch(`https://api.kcmstore.in/store/add-to-cart/${userData.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prod_name: product.name,
        item_qty: 1,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      console.log('✅ Cart synced with backend:', data);
    } else {
      console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
    }
  } catch (error) {
    console.error('⚠️ Network error while syncing cart:', error);
  }
          setResponse('Product added to cart.');
          setTimeout(() => {
            setResponse('');
            window.location.reload();
          }, 1000)
      };
      
      const productImages = product.image ? product.image.split(',') : [];
      const defaultImage = productImages[0];
  
      if (!selectedImage && defaultImage) {
          setSelectedImage(defaultImage);
      }
  
      const handleImageClick = (image) => {
          setSelectedImage(image);
      };


  const handleUploadPres = async (prodName) => {
    if (!prescriptionFile) {
      setResponse("Please select a prescription image and ensure you're logged in.");
      setTimeout(() => setResponse(''), 2000);
      return;
    }

    const formData = new FormData();
    formData.append('attachment', prescriptionFile);
    formData.append('prod_name', prodName);
    formData.append('user_id', userData.id);
    formData.append('status', 'Pending');

    try {
      const res = await fetch('https://api.kcmstore.in/store/upload-prescription', {
        method: 'POST',
        body: formData
      });

      const result = await res.json();

      if (res.ok) {
        setResponse('Prescription Uploaded. Wait for Approval.');
        setShowUploadBtn(false);
        setPrescriptionFile(null);
      } else {
        setResponse(result.message || 'Upload failed. Try again.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      setResponse('An error occurred while uploading.');
    }

    setTimeout(() => setResponse(''), 3000);
  };

  
  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const maxSize = 2 * 1024 * 1024;
  if (file.size > maxSize) {
            setResponse('File size cannot exceed 2MB.');
    setTimeout(() => setResponse(''), 3000);
    e.target.value = '';
    return;
  }

  setPrescriptionFile(file);
};

const handleQuantityChange = async (cartId, prod_name, action) => {
  // console.log(medicineId, action);
  const existingCart = cart || [];

  let updatedQty = 1;

  const updatedCart = existingCart.map(item => {
    if (item.prod_name == prod_name) {
      if (action === 'increment') {
        updatedQty = item.quantity + 1;
      } else {
        // 🚫 never go below 1
        updatedQty = item.quantity > 1 ? item.quantity - 1 : 1;
      }

      return { ...item, quantity: updatedQty };
    }
    return item;
  });


  setCart(updatedCart);
  setCartQty(updatedQty);

  try {
    await fetch(`https://api.kcmstore.in/store/update-quantity/${cartId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userData.id,
        item_qty: updatedQty,
      }),
    });
  } catch (error) {
    console.error('⚠️ Quantity update failed:', error);
  }
};


    
    return (
        <>
            <Header isUser={isUser} userData={userData} />
            <SubHeader message="Product Details" />

            <section className='py-5'>
                <div className="container px-4">

                    <div className="row">

                        <div className="col-lg-6 col-md-6 my-2">
                            <div className='product-img-outer'>
                                <div className='product-img-stock'>{product.stock == '0' ? 'Out of Stock !' : ''}</div>
                                <img src={`https://api.kcmstore.in/sUploads/${selectedImage}`} alt={product.name} className="product-img" />

                                <Swiper spaceBetween={20} slidesPerView={5} modules={[Autoplay, Navigation]} loop={true}
                                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 3,
                                            spaceBetween: 40,
                                        },
                                        576: {
                                            slidesPerView: 4,
                                            spaceBetween: 20,
                                        },

                                        768: {
                                            slidesPerView: 5,
                                            spaceBetween: 20,
                                        },
                                        992: {
                                            slidesPerView: 3,
                                            spaceBetween: 20,
                                        },
                                        1298: {
                                            slidesPerView: 5,
                                            spaceBetween: 20,
                                        }
                                    }}>
                                    {product.image && product.image.split(',').map((image, index) => (
                                        <SwiperSlide key={index}>
                                            <img
                                                src={`https://api.kcmstore.in/sUploads/${image}`}
                                                alt={`Product image ${index + 1}`}
                                                className="tab-image my-3"
                                                onClick={() => handleImageClick(image)}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 align-content-center my-2">
                          <p className='my-0'><span className='para-text bg-orange text-light fw-semibold rounded-pill px-3 py-1'>{product.brand || ''}</span></p>
                            <p className='sec-heading mb-0'>{product.name}</p>
                            <span className='fw-bold text-muted'>{product.unit}</span>

                            <p className='fs-5 fw-semibold mt-3'>Product Price: <br />
                            <span className='fs-4 featured-price'>₹ {product.sell_price}{product.discount_amount > 0 && (
                      <span className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                        {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                      </span>
                    )}</span></p>
                                                    {isInCart ?
                                                        // <button
                                                        //     className="login-btn2 px-3 mb-3">Added to Cart</button>
                                                    <p className='action-btn-area mt-0 mb-3'>
                                                        <span className='action-btn' onClick={() => handleQuantityChange(cartId, product.name, 'decrement')}>-</span>
                                                        {/* <span className='px-2'>{product.quantity}</span> */}
<span className='px-2'>{cartQty}</span>
                                                        <span className='action-btn' onClick={() => handleQuantityChange(cartId, product.name, 'increment')}>+</span></p>

                                                        : <button
                                                            className="login-btn2 px-3 mb-3"
                                                            onClick={() => handleAddCart(product)}
                                                            disabled={product.stock === '0'}
                                                        >+ Add to Cart</button>}
                                                                                    {/* <button className="login-btn2 px-3 mb-3" onClick={() => handleAddCart(product)}>Add to Cart <i class="fa-solid header-icon fa-bag-shopping"></i></button> */}
                            <p className='fw-semibold text-muted'>Category: {product.category}</p>
{product.added_pres === 'yes' && (
  <p className='featured-price fs-6'>Medical Prescription Required to Order this Medicine!</p>
)}

  {showUploadBtn && (
      <>
        <input
          type='file'
          accept='image/*'
          className='form-input my-2 w-auto'
          onChange={handleFileChange}
        /><br />
        <button className='login-btn2' onClick={() => handleUploadPres(product.name)}>
          Upload Prescription Image
        </button>
      </>
    )}
                        </div>

                    </div>
                    {/* row ends */}


                    <div className='row mt-4'>


                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Product Details</div>
                        <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded preserve-lines'>
                          {/* Manufactured On: {formatDate(product.mfg) || 'NA'}<br />
                            Expire On: {formatDate(product.exp) || 'NA'}<br /> */}
                            Brand: {product.brand || '-'}<br />
                            {/* Purchase Price: ₹ {product.purchase_price || 'NA'}<br /> */}
                            MRP: ₹ {product.org_price || 'NA'}<br />
                            Tax Type: {product.tax_type || 'NA'}<br />
                            Tax Amount: {(product.tax_amount == 'None' ? 'None' : `${product.tax_amount}%`) || 'NA'}<br /></p></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Composition</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.description || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.composition || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Description</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.description || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.description || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Prescription</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.prescription || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.prescription || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Side Effects</div>
                        <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded'>Most side effects do not
                            require any medical attention and disappear as your body adjusts to the medicine. Consult your doctor if
                            they persist or if you are worried about them</p></div>


                        {/* <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Seller Details</div>
                        <div className='col-lg-8 col-md-8 my-1'>
                            <div className='bg-light px-3 py-3 rounded'>
                                <p className='d-flex justify-content-between'><span>Branch Name:</span><span>{product.subadmin_name || 'NA'}</span> </p>
                                <p className='d-flex justify-content-between'><span>Seller Email:</span><span>{product.subadmin_email || 'NA'}</span> </p>
                                <p className='d-flex justify-content-between'><span>Seller Address:</span><span>{product.subadmin_address || 'NA'}</span> </p>
                            </div>
                        </div> */}


                    </div>
                    {/* row ends */}


                </div>
            </section>

            {response && <ResponseMsg message={response} />}
{loading && <Loading setLoading={setLoading} />}
        </>
    );
};

export default ProductDetails;
